import { RQAPICallWithData } from 'store/APIClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { UserGroupSummaryT } from 'business/definitions';
import { useDispatch } from 'store/hooks';

const useUpdateUserGroup = (
    userGroupId: number,
    groupName: string,
    userEmails: string[],
) => {
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async () => {
            const response = await RQAPICallWithData<UserGroupSummaryT>({
                endpoint: `auth/user_group/${userGroupId}`,
                body: { groupName, userEmails },
                method: 'PUT',
            });
            return response.content;
        },

        onSuccess: ({ data: updatedUserGroup, message }) => {
            dispatch.vision.notifyUser({
                message,
                snackType: 'success',
            });
            queryClient.setQueryData(
                ['getUserGroups', true],
                (oldUserGroups: UserGroupSummaryT[]) =>
                    oldUserGroups.map((userGroup) =>
                        userGroup.id === updatedUserGroup.id
                            ? updatedUserGroup
                            : userGroup,
                    ),
            );
        },
        meta: { useGlobalOnError: true },
    });
};

export default useUpdateUserGroup;
